<template>
  <div class="container">
    <div class="content-padding">
      <div class="content">
        <img
          class="bg"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/57dd0880b062a61b077c01ce8757257d.png"
          alt=""
          @load="bindLoadImage"
        />
        <div class="user-info" v-if="info && isLoadImage">
          <img class="avatar" :src="info.head_img" alt="" />
          <div class="nickname">{{ info.truename | filterName }}</div>
        </div>
        <div class="rule-btn" @click="jumpRules">活动规则</div>
        <!-- 案例库 -->
        <div>
          <van-swipe
            class="my-swipe"
            :autoplay="10000"
            :show-indicators="false"
            :loop="false"
            @change="changeSwipe"
          >
            <van-swipe-item
              class="swipe-item"
              v-for="(item, index) in caseList"
              :key="index"
            >
              <img class="swipe-image" :src="item" alt="" />
            </van-swipe-item>
          </van-swipe>
          <div class="indicators-list">
            <div
              class="indicators-item"
              :class="{ 'indicators-item-active': curSwipe == index }"
              v-for="(item, index) in caseList"
              :key="index"
            ></div>
          </div>
          <img
            class="logo"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-ques-logo"
            alt=""
          />
        </div>
      </div>
    </div>
    <div
      class="btn-content"
      :class="{ 'disabled-btn': info.activity_state != 1 }"
      @click="bindReceive"
      v-if="info"
    >
      <div v-if="info.activity_state == 0">活动未开始</div>
      <div v-if="info.activity_state == 1">
        <div class="text">免费领取</div>
        <div class="del">原价¥399</div>
      </div>
      <div v-if="info.activity_state == 2">活动已结束</div>
    </div>
    <van-overlay :show="showLogin" @click="showLogin = false">
      <LoginComponent
        v-if="showLogin"
        class="login-content"
        @close="bindLoginClose"
        @login="bindLogin"
      />
    </van-overlay>
    <van-loading
      class="v-loading"
      v-if="!loaded"
      text-color="#55417A"
      color="#55417A"
      vertical
      >加载中...</van-loading
    >
  </div>
</template>
<script>
import LoginComponent from './components/login.vue'
export default {
  components: {
    LoginComponent
  },
  data() {
    return {
      errorText: false,
      isFirst: true, //是否是第一次请求
      showLogin: false,
      loaded: false,
      isLoadImage: false,
      info: null,
      curSwipe: 0,
      caseList: [
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/4e031d1b4427531245ae8ab9476c5064.png',
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c4481e1f14f54c860b15cd9eb116c233.png',
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c946cad07f45a7788634f9382afc9226.png',
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/75ef5eaf34f0bfd32c9d123d6430efb5.png',
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9cf105ed6f9536eb98b9c8ad7c8e634a.png'
      ]
    }
  },
  filters: {
    filterName(name) {
      if (!name) {
        return ''
      }
      if (name.length > 10) {
        name = name.slice(0, 7) + '..'
      }
      return name
    }
  },
  created() {
    this.getData()
    //分享活动落地页曝光事件
    this.$buryPoint('APP_SHARE_ACTIVITY_V2_RECEIVE_PAGE', {})
  },
  methods: {
    changeSwipe(index) {
      this.curSwipe = index
    },
    jumpRules() {
      this.$router.push({
        path: '/camp-invite-v3/rules',
        query: {
          type: 0,
          activityId: this.$route.query.aid
        }
      })
    },
    bindLoadImage() {
      this.isLoadImage = true
    },
    getData() {
      let params = {
        invitation_id: this.$route.query.iid,
        activity_id: this.$route.query.aid
      }
      this.$http
        .getBaseApp('member/ActivitySys/getInvitationDetail', params)
        .then((res) => {
          res = res.data
          if (res.code === 200) {
            this.info = res.data
          } else {
            this.errorText = res.msg
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loaded = true
        })
    },
    bindLoginClose() {
      this.showLogin = false
    },
    //登陆领取
    bindLogin(options) {
      let { username, phone, code } = options
      let params = {
        phone: phone,
        invitation_id: this.$route.query.iid,
        activity_id: this.$route.query.aid,
        pid: this.$route.query.pid,
        cid: this.$route.query.cid,
        areaCode: '86',
        identify_code: code,
        truename: username,
        from: '1',
        gender: '0'
      }
      this.$http
        .getBaseApp('member/ActivitySys/receive', params)
        .then((res) => {
          res = res.data
          if (res.code === 200) {
            if (res.data && res.data.data) {
              sessionStorage.setItem('token', res.data.data || '')
              localStorage.setItem('token', res.data.data || '')
            }
            this.showLogin = false
            this.$toast(res.data.msg || '领取成功')
            //分享活动落地页领取成功
            this.$buryPoint('APP_SHARE_ACTIVITY_V2_RECEIVE_PAGE_SUCCESS', {})
            setTimeout(() => {
              this.$router.push({
                path: '/camp-invite-v3/receive',
                query: {
                  status: res.data.msg,
                  activityId: this.$route.query.aid,
                  pid: this.$route.query.pid,
                  cid: this.$route.query.cid
                }
              })
            }, 300)
          } else {
            this.$dialog.alert({
              title: '提示',
              message: res.msg
            })
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    bindReceive() {
      if (this.info.activity_state == 0) {
        this.$toast('活动未开始')
        return
      }
      if (this.info.activity_state == 2) {
        this.$toast('活动已结束')
        return
      }
      if (this.errorText) {
        this.$toast(this.errorText)
        return
      }
      //分享活动落地页点击领取事件
      this.$buryPoint('APP_SHARE_ACTIVITY_V2_RECEIVE_PAGE_BUTTON', {})
      this.showLogin = true
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  background: #ece7ff;
  min-height: 100vh;

  .content-padding {
    box-sizing: border-box;
    padding-bottom: 60px;
  }
  .content {
    position: relative;
  }
  .bg {
    width: 100%;
  }
  .user-info {
    width: 80%;
    position: absolute;
    left: 50%;
    top: 416px;
    transform: translate(-50%, 0%);
    display: flex;
    align-items: center;
    justify-content: center;
    .avatar {
      border-radius: 50%;
      overflow: hidden;
      width: 30px;
      height: 30px;
      margin-right: 9px;
    }
    .nickname {
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 20px;
      white-space: nowrap;
      max-width: 200px;
    }
  }
  .my-swipe {
    margin-bottom: 16px;
    .swipe-image {
      margin: 0 auto;
      width: 335px;
      height: 379px;
    }
  }
  .indicators-list {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 26px;
    .indicators-item {
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: rgba(0, 0, 0, 0.12);
      margin-right: 4px;
    }
    .indicators-item-active {
      width: 12px;
      height: 5px;
      background: #6236ff;
      border-radius: 3px;
    }
  }
  .logo {
    margin: 0 auto 24px;
    height: 18px;
  }
  .user-content {
    position: absolute;
    width: 100%;
    padding: 0px 44px;
    left: 0;
    top: 80px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .avatar {
      width: 36px;
      height: 36px;
      border-radius: 6px;
      margin-right: 12px;
    }
    .user-right {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      .username {
        font-size: 15px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #df687d;
        line-height: 22px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .user-desc {
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #55417a;
        line-height: 14px;
      }
    }
  }
  .btn-content {
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    text-align: center;
    height: 48px;
    // IOS底部兼容
    height: calc(48px + 0.5 * constant(safe-area-inset-bottom)); //兼容 IOS<11.2
    height: calc(48px + 0.5 * env(safe-area-inset-bottom)); //兼容 IOS>11.2
    background: #fe3875;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .text {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 22px;
    }
    .del {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(255, 255, 255, 0.5);
      line-height: 17px;
      text-decoration: line-through;
    }
  }
  .disabled-btn {
    background-color: #999;
    color: #fff;
  }
  .login-content {
    position: fixed;
    width: 100%;
    left: 0;
    bottom: 0;
  }
}
.v-loading {
  position: fixed;
  left: 50%;
  top: 30%;
  transform: translate(-50%, 0%);
  z-index: 1;
}
.rule-btn {
  position: fixed;
  right: 0;
  top: 110px;
  width: 25px;
  display: flex;
  text-align: center;
  background: rgb(51, 51, 51);
  border-radius: 8px 0px 0px 8px;
  padding: 8px 4px;
  box-sizing: border-box;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 15px;
  z-index: 1;
}
</style>
